import { Col } from 'antd'
import { CSSProperties, ReactNode } from 'react'
import InputCheckbox from '../InputCheckbox'
import { colors } from '@lmc/common/constants'

export type SideControlBarProps = {
  list?: Array<any>
  title: ReactNode
  subTitle: ReactNode
  children: ReactNode
  onChange?: any
  isMobile?: boolean
}
const SideControlBar = ({
  list,
  title,
  subTitle,
  children,
  onChange,
  isMobile,
}: SideControlBarProps) => {
  const styles = {
    container: {
      maxWidth: 250,
      borderRadius: 14,
      background: colors.white,
      padding: 28,
      ...(!isMobile && { top: 150, position: 'fixed' }),
    },
  }

  return (
    <Col id="side-control-bar" style={styles.container as CSSProperties}>
      {title}
      {subTitle}
      <br />
      {list?.map((item) => (
        <InputCheckbox
          key={item.id}
          label={item.title}
          value={item.isSelected}
          fluid
          onChange={() => onChange(item.id)}
          style={{ marginBottom: 10 }}
        />
      ))}
      <br />
      {children}
    </Col>
  )
}

export default SideControlBar
